

export const ASSOCIATION_DASHBOARD_SUMMARY_SUCCESS = 'ASSOCIATION_DASHBOARD_SUMMARY_SUCCESS';
export const ASSOCIATION_DASHBOARD_SUMMARY_FAILURE = 'ASSOCIATION_DASHBOARD_SUMMARY_FAILURE';

export const ASSOCIATION_DASHBOARD_CHANGE_LOG_SUCCESS = 'ASSOCIATION_DASHBOARD_CHANGE_LOG_SUCCESS';
export const ASSOCIATION_DASHBOARD_CHANGE_LOG_FAILURE = 'ASSOCIATION_DASHBOARD_CHANGE_LOG_FAILURE';


